<div class="custom-modal">
    <div class="modal-body">
        <div class="row pt-3 m-3 fw-bold font-18">
            {{ message }}
        </div>
    </div>
    <div class="modal-footer my-3">
        <button *ngIf="cancelBtn" (click)="activeModal.close(false)" type="submit" class="btn  {{ classCancelBtn }}">{{ cancelBtn }}</button>
        <button *ngIf="nextBtn" (click)="activeModal.close(true)" type="submit" class="btn {{ classConfirmBtn }}">{{ nextBtn }}</button>
    </div>
</div>
